import { inject, Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { AWSLambda } from '../AWSLambda.service';
import { AuthenticatorService } from '@aws-amplify/ui-angular';
import { Auth } from 'aws-amplify';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BalanceService {

  lambda = inject(AWSLambda)
  authService = inject(AuthService)

  private user = inject(AuthenticatorService).user;
  auth = inject(AuthService);

  // null = todavía no cargado (estado loading); number = valor cacheado
  private _balance$ = new BehaviorSubject<number | null>(null);
  public balance$ = this._balance$.asObservable();

  /** Devuelve el saldo cacheado en memoria, o null si todavía no se ha cargado. */
  getCachedBalance(): number | null {
    return this._balance$.getValue();
  }

  /** Actualiza el saldo cacheado. Llamado tanto por calculateBalance como por
   *  SignalWireService durante llamadas en tiempo real. */
  updateBalance(amount: number) {
    this._balance$.next(amount);
  }

  async calculateBalance(username?: string) {
    await this.auth.refresh();
    this.user = await Auth.currentAuthenticatedUser();

    const balance = await this.lambda.getLambdaFunction(
      'lambda',
      '/transactions/balance',
      //{ queryStringParameters: { owner: username ? username : this.authService.getUser().username } }
      { queryStringParameters: {
         owner: username ? username : this.user.username,
         phone:  localStorage.getItem("PhoneNumber"),
         action:"get"
        }
      }
    );
    const amount = parseFloat(parseFloat(balance.amount).toFixed(2));
    this._balance$.next(amount);
    return amount;
  }
}
